import { render, staticRenderFns } from "./deliveryNotePDF.vue?vue&type=template&id=60f8e8f6&"
import script from "./deliveryNotePDF.vue?vue&type=script&lang=js&"
export * from "./deliveryNotePDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports